import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ClipboardCheck, Trash2, BellRing } from "lucide-react";

const SETTE_GG = 7 * 24 * 3600 * 1000;
export const daVerificare = (m) => m.ubicazione === "cantiere" && (!m.verificato_at || Date.now() - new Date(m.verificato_at).getTime() > SETTE_GG);

export const VerificaBanner = ({ count }) => count > 0 && (
  <div className="rounded-md border border-amber-400 bg-amber-50 dark:bg-amber-900/10 p-3 text-sm flex items-center gap-2" data-testid="verifica-banner">
    <BellRing className="h-4 w-4 text-amber-600" />
    <span><strong>{count}</strong> materiali in cantiere da verificare: aggiorna la quantità rimasta o segnali come consumati.</span>
  </div>
);

export const VerificaDialog = ({ item, onClose, onDone }) => {
  const [qty, setQty] = useState("");
  const [busy, setBusy] = useState(false);
  const open = !!item;
  const send = async (body, msg) => {
    setBusy(true);
    try { await api.post(`/magazzino/${item.id}/verifica`, body); toast.success(msg); onDone(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    finally { setBusy(false); }
  };
  const conferma = () => send({ quantita: Number(String(qty === "" ? item.quantita : qty).replace(",", ".")) || 0 }, "Giacenza verificata");
  const consumato = () => window.confirm(`Segnare "${item.nome}" come consumato? L'articolo verrà eliminato.`) && send({ consumato: true }, "Segnato come consumato");

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setQty(""); onClose(); } }}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><ClipboardCheck className="h-5 w-5 text-primary" /> Verifica giacenza</DialogTitle></DialogHeader>
        {item && (
          <div className="space-y-3">
            <div className="rounded bg-secondary p-2 text-sm"><strong>{item.nome}</strong> · registrati {item.quantita} {item.unita_misura}</div>
            <div>
              <Label>Quantità rimasta ({item.unita_misura})</Label>
              <Input data-testid="verifica-qty" type="number" inputMode="decimal" min="0" step="any" placeholder={String(item.quantita)} value={qty} onChange={(e) => setQty(e.target.value)} className="h-11 text-lg font-bold text-center" />
            </div>
            <Button data-testid="verifica-conferma" disabled={busy} onClick={conferma} className="w-full h-11">Conferma quantità</Button>
            <Button data-testid="verifica-consumato" disabled={busy} variant="outline" onClick={consumato} className="w-full h-11 text-destructive">
              <Trash2 className="h-4 w-4 mr-2" /> Consumato, elimina
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
